<template>
  <div class="addr-form bg-grey pd-20 ">
    <a-form-model ref="form" class="my-form" layout="inline" :model="form" :rules="rules">
      <a-form-model-item style="display:none" class=" my-form-item " prop="addressType">
        <span slot="label">类　　型</span>
        <a-radio-group v-model="form.addressType" :default-value="addressType">
          <a-radio :value="2">
            收件地址
          </a-radio>
          <a-radio :value="1">
            寄件地址
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div class="flex">
        <a-form-model-item class=" my-form-item " prop="contactName">
          <span slot="label">姓　　名</span>
          <a-input
            v-model="form.contactName"
            class="w-200"
            placeholder="请输入姓名"
          />
        </a-form-model-item>
        <a-form-model-item class="my-form-item  " prop="companyName">
          <span slot="label">公　　司</span>
          <a-input
            v-model="form.companyName"
            class="w-200"
            placeholder="请输入公司名称"
          />
        </a-form-model-item>
      </div>
      <div class="flex">
        <a-form-model-item class=" my-form-item " prop="mobile">
          <span slot="label">联系方式</span>
          <a-input
            v-model="form.mobile"
            class="w-200"
            placeholder="请输入手机号/固话"
          />
        </a-form-model-item>
        <a-form-model-item class=" my-form-item " prop="phone">
          <!-- <span slot="label">固定电话</span>
          <a-input
            v-model="form.phone"
            class="w-200"
            placeholder="请输入固定电话"
          /> -->
        </a-form-model-item>
      </div>
      <a-form-model-item class="my-form-item  " prop="addrObj">
        <span slot="label">{{ form.addressType === 1?'寄件地址':'收件地址' }}</span>
        <Addr v-if="!flashAddr" class="mt-8 my-addr" :result.sync="form.addrObj" />
      </a-form-model-item>

    </a-form-model>
    <div class="mt-20">
      <a-button @click="reset">取消</a-button>
      <a-button type="primary" @click="save">保存</a-button>
    </div>
  </div>
</template>
<script>
import Addr from './addr'
import validate from '@framework/utils/biz-validate'

export default {
  components: {
    Addr
  },
  props: {
    addressType: {
      type: Number,
      default: 1
    },
    mode: {
      type: Number,
      default: 1 // 1为新增，2为编辑
    },
    info: {
      type: Object,
      default: null
    }

  },
  data() {
    // const validatePhone = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error('请输入正确的用户名'))
    //   } else {
    //     callback()
    //   }
    // }
    const validateMobile = (rule, value, callback) => {
      if (!this.$utils.rules.mobileOrPhone.pattern.test(value)) {
        callback(new Error(this.$utils.rules.mobileOrPhone.msg))
      } else {
        callback()
      }
    }
    // const validateMobile = (rule, value, callback) => {
    //   if (!validate.mobile.pattern.test(value)) {
    //     callback(new Error(validate.mobile.msg))
    //   } else {
    //     callback()
    //   }
    // }
    const validateAddr = (rule, value, callback) => {
      if (!value || !value.provinceCode) {
        callback(new Error('请选择省市区'))
      } else if (!value || !value.addressDetail) {
        callback(new Error('请填写详细地址'))
      } else {
        callback()
      }
    }

    return {
      flashAddr: false,
      addr: null,
      form: {
        addrObj: null,
        'addressDetail': '',
        'addressType': 0,
        'areaCode': '',
        'areaName': '',
        'cityCode': '',
        'cityName': '',
        'companyName': '',
        'contactName': '',
        'mobile': '',
        'phone': '',
        'provinceCode': '',
        'provinceName': ''
      },
      rules: {
        addressType: [{ required: true, message: '请选择地址类型' }],
        contactName: [{ required: true, message: '请输入姓名' }],
        mobile: [{ required: true, validator: validateMobile }],
        addrObj: [{ required: true, validator: validateAddr }]
      }
    }
  },
  watch: {
    info(n) {
      this.gennerateAddrObj(n)
      Object.assign(this.form, n)
    }
  },
  created() {
    this.form.addressType = this.addressType
    if (this.info) {
      this.gennerateAddrObj(this.info)
      Object.assign(this.form, this.info)
    }
  },
  methods: {
    gennerateAddrObj(n) {
      const addrObj = {
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        addressDetail: '',
        areaCode: '',
        areaName: ''
      }
      Object.keys(addrObj).forEach(el => {
        addrObj[el] = n[el]
      })
      n.addrObj = addrObj
    },
    reset() {
      this.$emit('cancel')
    },
    save() {
      this.$refs.form.validate(async(v) => {
        if (v) {
          const params = { ...this.form }
          delete params.addrObj
          Object.assign(params, this.form.addrObj)
          const api = params.id ? this.$api.addressUpdate : this.$api.addressAdd
          const res = await this.$http({ ...api, origin: true }, params)
          if (res && res.data && res.data.state === 'success') {
            this.form.addrObj = null
            this.flashAddr = true
            this.$nextTick(() => {
              this.flashAddr = false
            })
            // Object.assign(this.form.addrObj, {
            //   provinceCode: '',
            //   provinceName: '',
            //   cityCode: '',
            //   cityName: '',
            //   addressDetail: '',
            //   areaCode: '',
            //   areaName: ''
            // })
            Object.assign(this.form, {
              'addressDetail': '',
              'areaCode': '',
              'areaName': '',
              'cityCode': '',
              'cityName': '',
              'companyName': '',
              'contactName': '',
              'mobile': '',
              'phone': '',
              'provinceCode': '',
              'provinceName': ''
            })
            this.$emit('success')
          }
        }
      })
    //
    }
  }
}
</script>
<style lang="scss">
.addr-form{
    .my-addr{
        .ant-cascader-picker{
            width: 200px;
        }
        .ant-input{
            width: 295px;
        }
}
}

</style>
